export const Permissions = {
  AffiliateManager: "affiliate_manager",
  Admin: "admin",
  SuperAdmin: "super_admin",
  Compliance: "compliance",
};
